import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Segmented } from 'antd';
import styled from 'styled-components';
import { useLegendConfig } from '../../../../hooks/SimViewer/useLegendConfig';
import type { Legend } from '../../../../types/common';

type Props = {
  legends: Legend[];
};

const ScaleSwitcher = ({ legends }: Props): ReactNode => {
  const { t } = useTranslation();
  const {
    scaleType,
    customRange,
    setScaleType,
    setCustomRange,
    setDraftCustomRange,
    setIsEditingLegend,
  } = useLegendConfig();

  return (
    <StyledSegmented
      options={[
        {
          value: 'quantile',
          label: t('quantile'),
        },
        {
          value: 'quantize',
          label: t('quantize'),
        },
        {
          value: 'custom',
          label: t('custom'),
        },
      ]}
      value={scaleType}
      onChange={(value: string | number): void => {
        if (value === 'quantile' || value === 'quantize') {
          setScaleType(value);
          setIsEditingLegend(false);
        } else if (value === 'custom') {
          setScaleType(value);
          setIsEditingLegend(true);

          if (customRange.length > 0) {
            // 既にカスタム凡例が存在する場合は、それを使って編集を再開する
            setDraftCustomRange(customRange);
          } else {
            // 新規にカスタムスケールに切り替える場合は、現在の値を初期値として編集を開始する
            const initialRange = legends.map(
              (legend: Legend): [number, number] => {
                return legend.range;
              }
            );
            setCustomRange(initialRange);
            setDraftCustomRange(initialRange);
          }
        }
      }}
      block
    />
  );
};

const StyledSegmented = styled(Segmented)`
  width: 200px;
  .ant-segmented-item-label {
    padding: 0 2px;
  }
`;

export { ScaleSwitcher };
